import app from "@/main";

export default {
  isAuth: (state) => !!(state.tokens.access && state.tokens.refresh),
  accessToken: (state) => state.tokens.access,
  refreshToken: (state) => state.tokens.refresh,
  tempAccessToken: (state) => state.tokens.tempAccess,
  tempRefreshToken: (state) => state.tokens.tempRefresh,
  userStatus: (state) => state.status,
  getPlaidLinkToken: (state) => state.plaidToken,
  restoredData: (state) => state.restoredData,
  userId: (state) => state.userId,
  userEmail: (state) => state.userEmail,
  isGuestUser: () => JSON.parse(app.prototype.$DbStorage.getItem("isGuestUser")),
  paymentCompleted: (state) => state.paymentCompleted,
  ssoUser: (state) => state.ssoUser,
};
